<agpr-dialog-container
    [id]="'editSourceDialog'"
    heading="Sources.edit"
    (close)="cancel()"
>
    <div class="agpr-editSourceDialog">
        <agpr-text-input
            [id]="'editSourceDialog_name'"
            label="Sources.sourcePicker.create.name"
            placeholder="Sources.sourcePicker.create.name.placeholder"
            [(ngModel)]="sourceName"
            (ngModelChange)="validateName()"
            [ariaInvalid]="nameErrors.length > 0"
            [ariaDescribedBy]="'editSourceDialog_name_errors'"
        ></agpr-text-input>
        <div
            [id]="'editSourceDialog_name_errors'"
            *ngIf="nameErrors"
        >
            <agpr-form-message
                *ngFor="let error of nameErrors"
            >
                {{ error | localize }}
            </agpr-form-message>
        </div>
        <label
            [id]="'editSourceDialog_type_label'"
            class="agpr-editSourceDialog-type-label"
        >{{ 'Sources.sourcePicker.create.type' | localize }}</label>
        <div
            class="agpr-editSourceDialog-type"
            role="radiogroup"
            [attr.aria-labelledby]="'editSourceDialog_type_label'"
        >
            <agpr-radio
                [id]="'editSourceDialog_type_contact'"
                name="type"
                [value]="sourceTypes.journalist"
                [(ngModel)]="sourceType"
                [label]="'Common.journodex.' + sourceTypes.journalist"
            ></agpr-radio>
            <agpr-radio
                [id]="'editSourceDialog_type_outlet'"
                name="type"
                [value]="sourceTypes.outlet"
                [(ngModel)]="sourceType"
                [label]="'Common.journodex.' + sourceTypes.outlet"
            ></agpr-radio>
            <agpr-radio
                [id]="'editSourceDialog_type_url'"
                name="type"
                [value]="sourceTypes.url"
                [(ngModel)]="sourceType"
                [label]="'Common.journodex.' + sourceTypes.url"
            ></agpr-radio>
        </div>
        <agpr-panel
            *ngIf="existingGroupsChips.length"
            class="agpr-editSourceDialog-existingSources"
            header="Sources.inGroups"
        >
            <ul class="agpr-editSourceDialog-chips agpr-editSourceDialog-existingSources-chips">
                <li
                    *ngFor="let chip of existingGroupsChips; let i = index;"
                    class="agpr-chip"
                >
                    <span class="agpr-chip-label">{{ chip.label }}</span>
                    <button
                        [id]="'editSourceDialog_existingGroup_chip_' + i + '_delete'"
                        class="agpr-chip-icon agpr-i-close"
                        agprTooltip="Common.forms.chips.delete"
                        [useTooltipAsAriaLabel]="false"
                        tooltipPosition="top"
                        (click)="removeExistingGroup(chip)"
                        [attr.aria-label]="chip.label + ' ' + ('Common.forms.chips.delete' | localize)"
                    ></button>
                </li>
            </ul>
        </agpr-panel>
        <agpr-autocomplete
            [id]="'editSourceDialog_newGroups'"
            [dropdown]="true"
            [suggestions]="groupList$"
            label="SourceGroups.selection.add"
            placeholder="SourceGroups.selection.add.placeholder"
            labelField="name"
            [forceClearAfterSelection]="true"
            (itemSelected)="addNewGroup($event)"
        ></agpr-autocomplete>
        <div *ngIf="addToGroupsChips.length" class="agpr-editSourceDialog-newGroups">
            <ul class="agpr-editSourceDialog-chips agpr-editSourceDialog-newGroups-chips">
                <li
                    *ngFor="let chip of addToGroupsChips; let i = index;"
                    class="agpr-chip"
                >
                    <span class="agpr-chip-label">{{ chip.label }}</span>
                    <button
                        [id]="'editSourceDialog_newGroup_chip_' + i + '_delete'"
                        class="agpr-chip-icon agpr-i-close"
                        agprTooltip="Common.forms.chips.delete"
                        [useTooltipAsAriaLabel]="false"
                        tooltipPosition="top"
                        (click)="removeNewGroup(chip)"
                        [attr.aria-label]="chip.label + ' ' + ('Common.forms.chips.delete' | localize)"
                    ></button>
                </li>
            </ul>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="'editSourceDialog_cancel'"
            label="cancel"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="'editSourceDialog_ok'"
            [style]="buttonTypes.primary"
            [disabled]=""
            label="save"
            (click)="confirm()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>